import { IonButton, IonContent, IonFooter, IonImg, IonItem, IonLabel, IonNote, IonPage, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import './PrimeiroAcesso.css';
import imgTopo1 from './imgs/LogoCor.png';


const PrimeiroAcesso: React.FC = () => {
  const history = useHistory();


  useIonViewDidEnter(() => {
  });

  const logarEvent = () => {
    history.replace("/login");
  }

  const cadastrarEvent = () => {
    history.replace("/cadastro");
  }

  return (
    <IonPage>
      <IonContent>
        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ display: 'block', margin: 'auto', width: 'fit-content', height: 'fit-content' }}>
            <IonItem lines='none'>
              <div
                style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '10%',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '75px auto 50px auto'
                }}
              >
                <IonImg
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  src={imgTopo1}
                />
              </div>
            </IonItem>
            <IonItem lines='none'>
              <IonLabel className="ion-text-wrap" style={{ textAlign: 'center', padding: '0', margin: '0 5% 50px 5%', fontSize: '20px', color: '#333333' }}><b>Bem-vindo</b></IonLabel>
            </IonItem>
            <IonItem lines='none'>
              <IonLabel className="ion-text-wrap" style={{ margin: '0 5% 0 5%', color: '#333333', textAlign: 'justify', fontSize: '16px' }}>No Xeguei você faz seus pedidos online, economiza e ainda acompanha suas entregas em tempo real!</IonLabel>
            </IonItem>
          </div>
        </div>
      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton style={{ marginTop: '10px', marginBottom: '25px' }} size='large' expand='block' fill='solid' color='primary' onClick={() => { logarEvent(); }}>Já tenho cadastro</IonButton>
          <IonButton style={{ marginTop: '10px', marginBottom: '5px' }} size='large' expand='block' fill="solid" color="tertiary" onClick={() => { cadastrarEvent(); }}>Fazer cadastro</IonButton>
          <IonNote color="medium" style={{ textAlign: 'justify', margin: '0 25px 15px 25px', display: 'block' }}>
            É rápido e simples, para que você possa acompanhar seus pedidos.
          </IonNote>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default PrimeiroAcesso;
